var path = './analytics/exportButtonTooltip.html';
var html = "<div ng-bind-html=\"getExportDisabledReason() !== null ? getExportDisabledReason() : ('ANALYTICS.FILTER.BUTTONS.EXPORT_TOOLTIP'|translate)\" ng-click=\"markCompanionAsInstalled()\"></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;